import React from 'react';
import {useTranslation} from "react-i18next";
import {ShoppingBagIcon} from "@heroicons/react/24/outline";

function ProductsDetails({payment}) {
	const {t} = useTranslation();
	if (!payment?.products?.length) return null;

	return (
		<div className="bg-white rounded-[2rem] shadow-sm border border-gray-100 overflow-hidden">
			<div className="px-8 py-6 border-b border-gray-50 flex items-center justify-between">
				<div className="flex items-center gap-3">
					<div className="p-2.5 rounded-2xl bg-[#0b6a8c]/10">
						<ShoppingBagIcon className="h-6 w-6 text-[#0b6a8c]" />
					</div>
					<h3 className="text-lg font-bold text-gray-900">{t('invoice.items_services')}</h3>
				</div>
				<span className="bg-cyan-50 text-[#0b5f82] text-[10px] font-black uppercase tracking-wider px-3 py-1 rounded-full">
					{payment?.products?.length} {t('invoice.items')}
				</span>
			</div>
			<div className="overflow-x-auto">
				<table className="min-w-full bg-white">
					<thead>
						<tr className="bg-gray-50/50">
							<th scope="col" className="py-4 pl-8 pr-4 text-left text-[10px] font-black uppercase tracking-widest text-gray-400">
								{t('invoice.product')}
							</th>
							<th scope="col" className="px-4 py-4 text-left text-[10px] font-black uppercase tracking-widest text-gray-400">
								{t('invoice.amount')}
							</th>
							<th scope="col" className="px-4 py-4 text-left text-[10px] font-black uppercase tracking-widest text-gray-400">
								{t('invoice.vat')}
							</th>
							<th scope="col" className="px-4 py-4 text-left text-[10px] font-black uppercase tracking-widest text-gray-400">
								{t('invoice.quantity')}
							</th>
							<th scope="col" className="px-4 py-4 pr-8 text-right text-[10px] font-black uppercase tracking-widest text-gray-400">
								{t('invoice.total')}
							</th>
						</tr>
					</thead>
					<tbody className="divide-y divide-gray-50">
						{payment?.products?.map((product) => (
							<tr key={product.id} className="transition-all duration-300 hover:bg-gray-50/50 group">
								<td className="py-5 pl-8 pr-4 text-sm font-bold text-gray-900">
									{product.title}
									<div className="text-gray-400 font-medium text-xs mt-0.5">{product.details}</div>
								</td>
								<td className="px-4 py-5 text-sm font-semibold text-gray-600">
									{product?.amount} {payment?.currency?.symbol}
								</td>
								<td className="px-4 py-5 text-sm font-semibold text-gray-600">
									{product?.vat === 0 ? '—' : product.vat}
								</td>
								<td className="px-4 py-5 text-sm">
									<span className="bg-gray-100 text-gray-600 font-bold px-2.5 py-1 rounded-lg text-xs">
										× {product?.quantity}
									</span>
								</td>
								<td className="px-4 py-5 pr-8 text-right text-sm font-black text-[#0b5f82]">
									{product?.total} {payment?.currency?.symbol || ''}
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
}

export default ProductsDetails;
